/**
 * Created by mly on 2017/12/5.
 * 增删改查公用 数据 和 方法
 * 组件使用 mixins 引入
 */
import OSUtil from '../libs/outsource_util';
import FlowUtil from '../../../libs/flow_util';
import ViewerItem from '../../components/viewer/item';
import UserFlowBase from '../../components/flow/user_flow_base';
import {mapGetters} from "vuex";
import VForm from '@/vuetify_custom/v-form'
import {deleteOutsourceContractApi} from '../services'
export default {
  components: { ViewerItem, UserFlowBase },
  data() {
    return {
      params: {
        per_page: 10,
        page: 1,
        search: ''
      },
      page_info: {
        current: 1,
        total: 0,
        page_size: 10
      },
      contracts: [],
      base_columns: [
        {
          title: '详情',
          align: 'center',
          width: 50,
          fixed: 'left',
          render: (h, params) => {
            const row = params.row;
            return h(ViewerItem, {
              props: {
                type: 'OutsourceContract',
                model_id: row.id,
                tip: false
              },
              'class': {
                link: true
              }
            }, '查看')
          }
        },
        {
          title: '编号',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row;
            const ret = [
              h('div', row.uid)
            ]
            if (row.del) {
              ret.push(h('div', {
                'class': {
                  'color-error': true
                }
              }, '已废弃'));
            }
            if (!row.has_payment) {
              ret.push(h('div', {
                'class': {
                  'color-warning': true
                }
              }, '暂无付款记录'));
            }
            return h('div', {
              'class': {
                'text-center': true
              }
            }, ret);
          }
        },
        {
          title: '收款账户核验',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.threeCheckStatusName(row.three_check_status));
          }
        },
        {
          title: '姓名',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.account);
          }
        },
        {
          title: '公司/项目',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const company = this.companies_hash[row.company_id];
            const team = this.teams_hash[row.team_id];
            const text = `${company ? company.short_name : '-'}/${team ? team.name : '-'}`;
            return h('span', text);
          }
        },
        {
          title: '申请人',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return <CustomerName id={ row.apply_user_id } />
          }
        },
        {
          title: '负责人',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return <CustomerName id={ row.pay_user_id } />
          }
        },
        {
          title: '工作内容',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.job_content);
          }
        },
        {
          title: '预计金额',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row;
            return h('div', {
              'class': {
                'text-center': true
              }
            }, '￥' + this.$util.formatPrice(row.estimate_price));
          }
        },
        {
          title: '状态',
          minWidth: 125,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const user_flow = row.user_flow;
            if (user_flow) {
              return h(UserFlowBase, {
                props: {
                  user_flow: user_flow,
                  model: row,
                  title: row.name
                },
                'class': {
                  'text-left': true
                }
              })
            } else {
              return h('div', '-');
            }
          }
        },

      ],
      new_contract: this.$util.clone(OSUtil.new_contract),
      loading: false
    }
  },
  computed: {
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    select_teams() {
      const teams = [];
      teams.push({id: 0, name: '所有团队'});
      this.teams.forEach((team) => {
        teams.push(team);
      });
      return teams;
    },
    ...mapGetters({
      companies: 'async/companies',
      companies_hash: 'async/companies_hash',
      teams: 'async/root_teams',
      teams_hash: 'async/root_teams_hash',
    }),
  },
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    addContract() {
      // let content = '<p>大家好，因云账户改版及公司主体对口业务优化，将发生以下调整：</p>';
      // content += '<p>一、自2019年6月25日（含）起，得启用新的合同模板与签约方式（图示如下），无法接受旧版云账户合同申请。</p>';
      // content += '<p>二、截止到2019年6月25日（含），已将旧版云账户合同纸质原件交至法务侧的，后续财务结算不受影响；逾期未交原件的，将无法按照旧合同结算，须申请新合同，方可结算。</p>';
      // this.$Modal.confirm({
      //     title: '提示',
      //     content: content,
      //     onOk: ()=>{
      //         this.$refs.editor.add();
      //     }
      // });
      this.$refs.editor.add();
    },
    editContract(contract) {
      this.$refs.editor.edit(contract);
    },
    beforeSearch() {
      this.loading = true;
      this.params.page = 1;
      this.contracts = [];
    },
    pageChange(new_page) {
      this.params.page = new_page;
      this.loading = true;
      this.$refs.searchBtn.doAjax(true);
    },
    doSearch() {
      this.params.page = 1;
      this.loading = true;
      this.$refs.searchBtn.doAjax();
    },
    handleContractData(data) {
      this.contracts = data.contracts
      this.page_info.current = data.cur_page;
      this.page_info.page_size = data.per_page;
      this.page_info.total = data.total_count;
    },
    handleContractFail(e) {
      this.$Modal.error({title: '保存失败', content: e.message});
    },
    handleContractFinally() {
      this.loading = false;
    },
    updateContract(contract) {
      if (contract.user_flow) {
        this.$util.insertOrUpdateArrayItem(this.contracts, contract, true);
      } else {
        this.doSearch();
      }
    },
    deleteContractV1(contract) {
      let del_reason = ''
      this.$vModal.confirm({
        title: '提示',
        loading: true,
        render: (h) => {
          
          return h(VForm, {
          
            props: {
              fields: [
                {
                label: '废弃原因',
                key:'del_reason',
                type:'textareas_field',
                required: true,
                rows: 4,
                cols: 12,
                counter: 128,
                rules:[val => {
                    if (!val) {
                        return '必选'
                    }
                    if (!!val && val.length > 128) {
                        return '不能超过128个字符'
                    }
                  return true
                }],
                change: (s) => {
                  del_reason = s
                }
            }]
            }
          })
        },
        onOk:({destroy, stopLoading}) => {
       
          setTimeout(() => {
            if (!del_reason || !del_reason.trim()) {
              this.$Message.error('废弃原因必填！')
              stopLoading()
              return 
            }
            deleteOutsourceContractApi({
              id: contract.id,
              del_reason
            }).then(() => {
              this.$Message.success('废弃成功！')
              destroy()
              this.doSearch()
            }).finally(() => {
              stopLoading()
            })
          }, 200)
        }
      })
    },
    deleteContract(contract) {
      this.$Modal.confirm({
        title: '提示',
        content: '你确定要废弃吗?',
        onOk: () => {
          this.$util.ajax.post(this.$util.api.delete_outsource_contract, {
            id: contract.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              contract.del = true;
              this.$Message.success('删除成功!');
            } else {
              this.$Modal.error({title: '提示', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.error({title: '提示', content: e.message});
          });
        }
      })
    },
    editOutsourceExpenseGroup(outsource_contract) {
      const outsource_id_number = outsource_contract.id_number || '';
      localStorage.setItem('outsource_id_number', outsource_id_number);
      let outsource_bank_number = '';
      if (outsource_contract.payment_type === 'bank') {
        outsource_bank_number = outsource_contract.bank_number;
      } else if (outsource_contract.payment_type === 'alipay') {
        outsource_bank_number = outsource_contract.alipay;
      }
      localStorage.setItem('outsource_bank_number', outsource_bank_number);
      window.open('/mine/expense_group_company', '_blank');
    },
  }
}
